import { SVGProps } from 'react';

const Asterisk = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 6v12m5.196-9L6.804 15m0-6 10.392 6"
    />
  </svg>
);
export default Asterisk;
